import { RetryLink } from '@apollo/client/link/retry';
import { getMainDefinition } from '@apollo/client/utilities';

const isServer = !globalThis.document;

const isMutation = operation => {
  try {
    const definition = getMainDefinition(operation.query);

    return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
  } catch (e) {
    return false;
  }
};

export default function createRetryLink() {
  return new RetryLink({
    delay: {
      initial: 300,
      max: Infinity,
      jitter: true,
    },
    attempts: {
      max: 5,
      retryIf: (error, operation) => {
        if (!error || isServer || !navigator.onLine) {
          return false;
        }

        // mutation 重试存在重复提交风险（重复加车、重复下单），一律不重试
        if (isMutation(operation)) {
          return false;
        }

        // 4xx 是服务端或 CDN 的明确拒绝（如 WAF 返回 403），重试不会成功，
        // 反而会因短时间内重复命中拦截规则而被升级为限速甚至封禁 IP
        const { statusCode } = error;

        if (typeof statusCode === 'number' && statusCode >= 400 && statusCode < 500) {
          return false;
        }

        return true;
      },
    },
  });
}
